import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { faCheckCircle, faPencil, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NumericFormat } from 'react-number-format';
import { CircularProgress } from '@mui/material';
import classNames from 'classnames';

function CommonDefaultTextInput({
  label,
  initialValue,
  decimalScale,
  labelClassName,
  maxLength,
  onSave,
}) {
  const [spinner, setSpinner] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [value, setValue] = useState(initialValue);

  const handleSave = async v => {
    setSpinner(true);
    await onSave(v);
    setValue(v);
    setEditMode(false);
    setSpinner(false);
  };

  const handleCancel = () => {
    setEditMode(!editMode);
    setValue(initialValue);
  };

  return (
    <>
      <Form.Label className={`bo-common-input-label ${labelClassName}`}>{label}</Form.Label>
      {editMode ? (
        <div className="bo-common-text-input-container">
          <div className="w-100">
            <NumericFormat
              type="text"
              className="bo-common-text-input"
              value={value}
              onValueChange={({ floatValue }) => setValue(floatValue)}
              maxLength={maxLength}
              customInput={Form.Control}
              allowNegative={false}
              decimalScale={decimalScale || 0}
              allowLeadingZeros={false}
              readOnly={spinner}
            />
            <div
              className={classNames(
                'bo-common-text-bottom-border',
                'bo-common-text-bottom-border-active',
              )}
            />
          </div>
          <div
            className={classNames(
              'bo-common-input-button-container',
              'bo-common-input-button-container-active',
            )}
          >
            {spinner ? (
              <div className="h-100">
                <CircularProgress color="inherit" size={16} />
              </div>
            ) : (
              <>
                <Button
                  className="bo-common-input-button-icon"
                  onClick={() => handleSave(value)}
                  disabled={(maxLength && value && String(value).length !== maxLength) || !value}
                >
                  <FontAwesomeIcon icon={faCheckCircle} color="#5946A4" size="1x" />
                </Button>
                <Button className="bo-common-input-button-icon" onClick={handleCancel}>
                  <FontAwesomeIcon icon={faTimesCircle} color="#5946A4" size="1x" />
                </Button>
              </>
            )}
          </div>
        </div>
      ) : (
        <div className="d-flex">
          <Button
            className="bo-common-text-input-container"
            onClick={() => setEditMode(true)}
            disabled={spinner}
          >
            <div className="w-100">
              <Form.Control
                className="bo-common-text-input"
                type="text"
                readOnly
                value={value === null ? 'Default' : value}
                onChange={e => setValue(e.target.value)}
              />
              <div className="bo-common-text-bottom-border" />
            </div>
            <div className={`bo-common-input-button-container ${value !== null && 'invisible'}`}>
              <div className="bo-common-input-button-icon">
                <FontAwesomeIcon icon={faPencil} color="#5946A4" size="sm" />
              </div>
            </div>
          </Button>
          {value !== null &&
            (spinner ? (
              <div className="h-100">
                <CircularProgress color="inherit" size={16} />
              </div>
            ) : (
              <Button
                className="bo-common-inline-button text-nowrap ms-1"
                onClick={() => handleSave(null)}
              >
                Reset to default
              </Button>
            ))}
        </div>
      )}
    </>
  );
}

export default CommonDefaultTextInput;
